import React, { useState } from 'react'

import { ListItemText, TextField } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { formField } from 'decorators'

import { input } from '@albacross/frontend-utils'

import { matchingFromServer } from 'models/name-to-domain-model'
import debounceEventHandler from 'utils/debounceEventHandler'
import { post } from 'utils/http'

type NameDoDomainFormNameFieldProps = {
  value: any
  onBlur: (...args: any[]) => any
  onChange: (...args: any[]) => any
  onFocus: (...args: any[]) => any
  errorId?: boolean | string
}

const NameDoDomainFormNameField = ({ value, onBlur, onChange, onFocus, errorId }: NameDoDomainFormNameFieldProps) => {
  const [matchings, setMatchings] = useState<any[]>([])

  const fetchData = async (search: any) => {
    if (!search) return

    const result: any = await post('/management/companies/name_to_domain/aliases', [search])
    setMatchings(result.find((item: any) => item.search === search).matchings.map(matchingFromServer))
  }

  const filterOptions = (options: any, params: any) => {
    if (params.inputValue !== '') {
      options.push({
        alias: params.inputValue,
        label: `Add "${params.inputValue}"`,
        verified: true,
      })
    }
    return options
  }

  const handleSearch = (event: any) => {
    if (!event) return
    fetchData(event.target.value)
  }

  return (
    <Autocomplete
      filterOptions={filterOptions}
      getOptionLabel={(option: any) => (!option.name ? option.alias : option.label) || ''}
      onChange={(_event: any, newValue: any) => onChange(newValue)}
      onClose={onBlur}
      onInputChange={debounceEventHandler(handleSearch, 300)}
      onOpen={onFocus}
      options={matchings}
      renderInput={(params: any) => <TextField {...params} error={!!errorId} helperText={errorId} placeholder="Name" />}
      renderOption={(props: any, option: any) => {
        const { key, ...optionProps } = props
        return (
          <li key={key} {...optionProps}>
            <ListItemText primary={option.label} secondary={option.name} />
          </li>
        )
      }}
      value={value}
    />
  )
}

export default formField(input({}, true, { noFieldEvents: true })(NameDoDomainFormNameField))
